import { createSelector } from 'reselect';

const selectHolidayBorder = state => state.holidayBorder;

export const selectHolidayBorderLeft = createSelector(
  selectHolidayBorder,
  holidayBorder => holidayBorder.holidayBorderLeft,
);

export const selectHolidayBorderLeftConfig = createSelector(
  selectHolidayBorderLeft,
  holidayBorderLeft => holidayBorderLeft.config,
);

export const selectHolidayBorderLeftIsLoading = createSelector(
  selectHolidayBorderLeft,
  holidayBorderLeft => holidayBorderLeft.isLoading,
);

export const selectHolidayBorderLeftIsLoaded = createSelector(
  selectHolidayBorderLeft,
  holidayBorderLeft => holidayBorderLeft.isLoaded,
);

export const selectHolidayBorderLeftPlacement = createSelector(
  selectHolidayBorderLeft,
  holidayBorderLeft => holidayBorderLeft.data,
);

export const selectHolidayBorderLeftImage = createSelector(
  selectHolidayBorderLeftPlacement,
  holidayBorderLeft => holidayBorderLeft?.assets?.image,
);

export const selectHolidayBorderLeftImageAlternateText = createSelector(
  selectHolidayBorderLeftPlacement,
  holidayBorderLeft => holidayBorderLeft?.assets?.imageAlternateText,
);

export const selectHolidayBorderRight = createSelector(
  selectHolidayBorder,
  holidayBorder => holidayBorder.holidayBorderRight,
);

export const selectHolidayBorderRightConfig = createSelector(
  selectHolidayBorderRight,
  holidayBorderRight => holidayBorderRight.config,
);

export const selectHolidayBorderRightIsLoading = createSelector(
  selectHolidayBorderRight,
  holidayBorderRight => holidayBorderRight.isLoading,
);

export const selectHolidayBorderRightIsLoaded = createSelector(
  selectHolidayBorderRight,
  holidayBorderRight => holidayBorderRight.isLoaded,
);

export const selectHolidayBorderRightPlacement = createSelector(
  selectHolidayBorderRight,
  holidayBorderRight => holidayBorderRight.data,
);

export const selectHolidayBorderRightImage = createSelector(
  selectHolidayBorderRightPlacement,
  holidayBorderRight => holidayBorderRight?.assets?.image,
);

export const selectHolidayBorderRightImageAlternateText = createSelector(
  selectHolidayBorderRightPlacement,
  holidayBorderRight => holidayBorderRight?.assets?.imageAlternateText,
);
